export default __webpack_public_path__ + "static/media/koi.6cc4de93.png";